import React from "react";
import PropTypes from "prop-types";
// react plugin for creating charts
import moment from "moment";
import ChartistGraph from "react-chartist";
import {VectorMap} from "react-jvectormap";
import ctPointLabels from '../../variables/chartUtil.js';
import Chartist from 'chartist';
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import AccessTime from "@material-ui/icons/AccessTime";
import Refresh from "@material-ui/icons/Refresh";
import Edit from "@material-ui/icons/Edit";
import Language from "@material-ui/icons/Language";
import Assignment from "@material-ui/icons/Assignment";
import Person from "@material-ui/icons/Person";
import {Redirect} from 'react-router';
import api from '../../api/Api'
import Icon from '@material-ui/core/Icon';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Table from "components/Table/Table.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Danger from "components/Typography/Danger.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import {Link} from "react-router-dom";

import ReactTable from "react-table";
import "react-table/react-table.css";
import {
    dailySalesChart,
    emailsSubscriptionChart,
    completedTasksChart
} from "variables/charts";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";

import priceImage1 from "assets/img/card-2.jpeg";
import priceImage2 from "assets/img/card-3.jpeg";
import priceImage3 from "assets/img/card-1.jpeg";
import localStorageHelper from "./../../localStorageHelper";
import {
    mappingUI,
    dashboardRouter,
    isClinicMasterOrClinic,
    clinicmaster_id,
    getClinicUserId,
    getDateConverter
} from '../../util/globalHelper';
import Loader from '../../components/Loader'

import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {
    reload
} from '../../redux/global'

const us_flag = require("assets/img/flags/US.png");
const de_flag = require("assets/img/flags/DE.png");
const au_flag = require("assets/img/flags/AU.png");
const gb_flag = require("assets/img/flags/GB.png");
const ro_flag = require("assets/img/flags/RO.png");
const br_flag = require("assets/img/flags/BR.png");
let values = [
    [2, 1, 3.5, 7, 3, 9]
];

var mapData = {
    AU: 760,
    BR: 550,
    CA: 120,
    DE: 1300,
    FR: 540,
    GB: 690,
    GE: 200,
    IN: 200,
    RO: 600,
    RU: 300,
    US: 2920
};
let a = [];
var delays = 80,
    durations = 500;
var delays2 = 80,
    durations2 = 500;

function maxValue(array) {
    return Math.max(...array)
}

const option = {
    data: {
        labels: [1, 2, 3],
        series: [
            [
                {meta: 'description', value: 1},
                {meta: 'description', value: 5},
                {meta: 'description', value: 3}
            ],
            [
                {meta: 'other description', value: 2},
                {meta: 'other description', value: 4},
                {meta: 'other description', value: 2}
            ]
        ]
    },
    options: {
        lineSmooth: Chartist.Interpolation.cardinal({
            tension: 0
        }),
        showPoint: true,
        low: 0,
        high: {
            draw: function (data) {
               return  Math.max(...data.series) + 10
            }

        }, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
        chartPadding: {
            top: 20,
            right: 0,
            bottom: 0,
            left: 0,
        },
        axisY: {
            onlyInteger: true
        },
        plugins: [
            Chartist.plugins.tooltip()
        ]
    },
    // for animation
    animation: {
        draw: function (data) {
            if (data.type === "line" || data.type === "area") {
                data.element.animate({
                    d: {
                        begin: 600,
                        dur: 700,
                        from: data.path
                            .clone()
                            .scale(1, 0)
                            .translate(0, data.chartRect.height())
                            .stringify(),
                        to: data.path.clone().stringify(),
                        easing: Chartist.Svg.Easing.easeOutQuint
                    }
                });
            } else if (data.type === "point") {
                data.element.animate({
                    opacity: {
                        begin: (data.index + 1) * delays,
                        dur: durations,
                        from: 0,
                        to: 1,
                        easing: "ease"
                    }
                });
            }
        }
    }
};

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            open: true,
            element: "",
            api_status: "",
            read: false,
            alert: null,
            clinicMasterList: null,
            clickedId: "",
            selectedId: "",
            value: 0,
            clinicsData: null,
            clinicmaster_id: null,
            analyticsList: null,
            reportLabel: [],
            reportSeries: [],
            appointmentLabel: [],
            appointmentSeries: [],
            patientLabel: [],
            patientSeries: [],
            reportGraph: {},
            appointmentGraph: {},
            patientGraph: {},
            graphType: 2,
            appointments: null,
            newAppointments: null

        };
        this.onChange = this.onChange.bind(this)
        this.changeGraph = this.changeGraph.bind(this)
    }

    renderGraphValue(array) {
        return array.map(item => {
            a.push.apply(a, Object.values(item))
            return Object.keys(item)
        })
    }

    renderGraphKeys(array) {
        return array.map(item => {
            a.push.apply(a, Object.keys(item))
            return Object.keys(item)
        })
    }

    renderGraphKey(array) {
        return array.map(item => {
            a.push.apply(a, Object.keys(item))
            return Object.keys(item)
        })
    }


    componentDidMount() {

        // if (this.props.reloadState) {
        //     window.location.reload();
        // }
        this.setState({clinicmaster_id: clinicmaster_id(), clinic_id: getClinicUserId()}, () => {
            this.CallReadApi()
        })
    }

    handleChange = (event, value) => {
        this.setState({value});
    };
    handleChangeIndex = index => {
        this.setState({value: index});
    };
    CallReadApi = () => {
        var postBody = {
            "clinic_master_id": this.state.clinicmaster_id ? this.state.clinicmaster_id : "",
            "clinic_id": this.state.clinic_id ? this.state.clinic_id : "",
        };
        api.fetAnalytticsStats({type: this.state.graphType}).then(json => {
            this.setState({
                data: json.data.data,
                reportLabel: Object.keys(json.data.data.report_details),
                reportSeries: [Object.values(json.data.data.report_details).map(b => {
                    return {meta: "Report: ", value: b}
                })],
                appointmentLabel: Object.keys(json.data.data.appointment_details),
                appointmentSeries: [Object.values(json.data.data.appointment_details).map(b => {
                    return {meta: "Appointment: ", value: b}
                })],
                patientLabel: Object.keys(json.data.data.patient_details),
                patientSeries: [Object.values(json.data.data.patient_details).map(b => {
                    return {meta: "Patient: ", value: b}
                })],
                analyticsList: json.data.data,
                reportGraph: {
                    labels: Object.keys(json.data.data.report_details),
                    series: [Object.values(json.data.data.report_details).map(b => {
                        return {meta: "Report: ", value: b}
                    })]
                },
                appointmentGraph: {
                    labels: Object.keys(json.data.data.appointment_details),
                    series: [Object.values(json.data.data.appointment_details).map(b => {
                        return {meta: "Appointment: ", value: b}
                    })]
                }, patientGraph: {
                    labels: Object.keys(json.data.data.patient_details),
                    series: [Object.values(json.data.data.patient_details).map(b => {
                        return {meta: "Patient: ", value: b}
                    })]
                }
            })
        });

        api.getAppointmentRequests({})
            .then(json => {
                if (!json.data.isError) {
                    this.setState({requestList: json.data.data});
                    localStorageHelper.setItem("requestList", json.data.data)
                } else {
                    this.setState({requestList: []});
                    localStorageHelper.setItem("requestList", [])
                }
            });
        isClinicMasterOrClinic() === "" ? api.listClinicMaster().then(json => {
            this.setState({clinicMasterList: json.data.data})
        }) : this.setState({clinicMasterList: {}});
        api.getAppointment({
            start_date: moment().format('YYYY-MM-DD'),
            end_date: moment().format('YYYY-MM-DD'),
            // end_date: new Date(new Date().setHours(23, 59, 0, 0)).getTime(),
            // start_date: new Date(new Date().setHours(0, 0, 0, 0)).getTime()
        }).then(json => {
            if (!json.data.isError) {
                this.setState({
                    appointments: json.data.data, newAppointments: json.data.data.map((item => {
                        return [item.patient_id && item.patient_id.user_id ? item.patient_id.user_id.name : "No Name", item ? getDateConverter(item.date) + ` ${item.local_start_time ? item.local_start_time : "No Time"}` : "No Date", item.patient_id && item.patient_id.user_id ? item.patient_id.user_id.contact : "-",
                            <Link to={dashboardRouter(`/appointment/view/${item._id}`)}>
                                <Tooltip
                                    id="tooltip-top"
                                    title="View"
                                    placement="bottom"
                                    classes={{tooltip: this.props.classes.tooltip}}>
                                    <Button type="button" color="info"
                                            style={{
                                                padding: 8,
                                                marginLeft: '10%'
                                            }}>
                                        <Icon
                                            style={{fontSize: 20}}>info</Icon>
                                    </Button></Tooltip></Link>]
                    }))
                })
            } else {
                this.setState({
                    appointments: []
                })
            }
        });
        // api.registerUser({});
    };

    onChange(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.changeGraph(e.target.value)

    }

    changeGraph(value) {
        api.fetAnalytticsStats({type: value}).then(json => {
            this.setState({
                graphType: value,
                data: json.data.data,
                reportLabel: Object.keys(json.data.data.report_details),
                reportSeries: [Object.values(json.data.data.report_details).map(b => {
                    return {meta: "Report:", value: b}
                })],
                appointmentLabel: Object.keys(json.data.data.appointment_details),
                appointmentSeries: [Object.values(json.data.data.appointment_details).map(b => {
                    return {meta: "Appointment:", value: b}
                })],
                patientLabel: Object.keys(json.data.data.patient_details),
                patientSeries: [Object.values(json.data.data.patient_details).map(b => {
                    return {meta: "Patient:", value: b}
                })],
                analyticsList: json.data.data,
                reportGraph: {
                    labels: Object.keys(json.data.data.report_details),
                    series: [Object.values(json.data.data.report_details).map(b => {
                        return {meta: "Report:", value: b}
                    })]
                },
                appointmentGraph: {
                    labels: Object.keys(json.data.data.appointment_details),
                    series: [Object.values(json.data.data.appointment_details).map(b => {
                        return {meta: "Appointment:", value: b}
                    })]
                }, patientGraph: {
                    labels: Object.keys(json.data.data.patient_details),
                    series: [Object.values(json.data.data.patient_details).map(b => {
                        return {meta: "Patient:", value: b}
                    })]
                }
            })
        });

    }

    render() {
        const {data, clinicMasterList, clinicsData, analyticsList, appointments} = this.state;
        const {classes} = this.props;
        return (
            <div>
                {analyticsList ? <div>
                    <GridContainer>
                        <GridItem xs={12} sm={6} md={6} lg={4}>
                            <Card>
                                <CardHeader color="info" stats icon>
                                    <CardIcon color="info">
                                        <Assignment/>
                                    </CardIcon>
                                    <p className={classes.cardCategory}>Report Count</p>
                                    <h3 className={classes.cardTitle}>{analyticsList.reports_count}</h3>
                                </CardHeader>
                                <CardBody>
                                </CardBody>
                                {/*<CardFooter stats>
                                    <div className={classes.stats}>
                                        <DateRange />
                                        Last 24 Hours
                                    </div>
                                </CardFooter> */}
                            </Card>
                        </GridItem>

                        <GridItem xs={12} sm={6} md={6} lg={4}>
                            <Card>
                                <CardHeader color="warning" stats icon>
                                    <CardIcon color="warning">
                                        <DateRange/>
                                    </CardIcon>
                                    <p className={classes.cardCategory}>Appointment Count</p>
                                    <h3 className={classes.cardTitle}>{analyticsList.appointments_count}</h3>
                                </CardHeader>
                                <CardBody>
                                </CardBody>
                                {/*<CardFooter stats>
                                    <div className={classes.stats}>
                                        <DateRange />
                                        Last 24 Hours
                                    </div>
                                </CardFooter>*/}
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={6} md={6} lg={4}>
                            <Card>
                                <CardHeader color="danger" stats icon>
                                    <CardIcon color="danger">
                                        <Person/>
                                    </CardIcon>
                                    <p className={classes.cardCategory}>Patient Count</p>
                                    <h3 className={classes.cardTitle}>
                                        {analyticsList.patient_count}
                                        {/*<small>GB</small>*/}
                                    </h3>
                                </CardHeader>
                                <CardBody>
                                </CardBody>
                                {/*<CardFooter stats>
                                    <div className={classes.stats}>
                                        <div className={classes.stats}>
                                            <DateRange />
                                            Last 24 Hours
                                        </div>
                                    </div>
                                </CardFooter> */}
                            </Card>
                        </GridItem>
                    </GridContainer>
                    <GridContainer>
                        <GridItem xs={12}>
                            <Card>
                                <CardHeader color="success" icon>
                                    <CardIcon color="success">
                                        <Language/>
                                    </CardIcon>
                                    <h4 className={classes.cardIconTitle}>
                                        Today's Appointments
                                    </h4>
                                </CardHeader>
                                <CardBody>
                                    <GridContainer justify="space-between">
                                        <GridItem xs={12} sm={12} md={12}>
                                            {this.state.newAppointments !== null ? <Table
                                                tableData={this.state.newAppointments}
                                            /> : <GridItem xs={12}
                                                           style={{justifyContent: 'center', textAlign: 'center'}}>
                                                <h5>No Appointments</h5>
                                            </GridItem>}
                                        </GridItem>
                                    </GridContainer>
                                </CardBody>
                            </Card>
                        </GridItem>
                    </GridContainer>
                    <GridContainer>

                        <GridItem xs={12} sm={12} md={12}>
                            <div style={{padding: '20px', margin: 'auto'}}>
                                <ul className="appointmentTiming centerDiv">
                                    <li>
                                        <input name="slot"
                                               defaultChecked={this.state.graphType === 4}
                                               type="radio" onChange={this.onChange}
                                               id={"day"} value={4}/>
                                        <label htmlFor={"day"}>{"Day"}</label>
                                    </li>
                                    <li>
                                        <input name="slot"
                                               defaultChecked={this.state.graphType === 1}
                                               type="radio" onChange={this.onChange}
                                               id={"week"} value={1}/>
                                        <label htmlFor={"week"}>{"Week"}</label>
                                    </li>
                                    <li>
                                        <input name="slot"
                                               defaultChecked={this.state.graphType === 2}
                                               type="radio" onChange={this.onChange}
                                               id={"month"} value={2}/>
                                        <label htmlFor={"month"}>{"Month"}</label>
                                    </li>
                                </ul>
                            </div>
                        </GridItem>

                    </GridContainer>
                    <br/>
                    <br/>
                    <br/>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={4}>
                            <Card chart className={classes.cardHover}>
                                <CardHeader color="info" className={classes.cardHeaderHover}>

                                    <ChartistGraph
                                        className="ct-chart-white-colors"
                                        data={this.state.reportGraph}
                                        type="Line"
                                        options={option.options}
                                        listener={dailySalesChart.animation}
                                    />
                                </CardHeader>
                                <CardBody>
                                    <div className={classes.cardHoverUnder}>
                                        <Tooltip
                                            id="tooltip-top"
                                            title="Refresh"
                                            placement="bottom"
                                            classes={{tooltip: classes.tooltip}}
                                        >
                                            <Button simple color="info" justIcon>
                                                <Refresh className={classes.underChartIcons}/>
                                            </Button>
                                        </Tooltip>
                                        <Tooltip
                                            id="tooltip-top"
                                            title="Change Date"
                                            placement="bottom"
                                            classes={{tooltip: classes.tooltip}}
                                        >
                                            <Button color="transparent" simple justIcon>
                                                <Edit className={classes.underChartIcons}/>
                                            </Button>
                                        </Tooltip>
                                    </div>
                                    <h4 className={classes.cardTitle}>Report Graph</h4>
                                </CardBody>
                                {/*<CardFooter chart>
                                    <div className={classes.stats}>
                                        <AccessTime /> updated 4 minutes ago
                                    </div>
                                </CardFooter>*/}
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={4}>
                            <Card chart className={classes.cardHover}>
                                <CardHeader color="warning" className={classes.cardHeaderHover}>
                                    <ChartistGraph
                                        className="ct-chart-white-colors"
                                        data={this.state.appointmentGraph}
                                        type="Line"
                                        options={option.options}
                                        listener={dailySalesChart.animation}
                                    />
                                </CardHeader>
                                <CardBody>
                                    <div className={classes.cardHoverUnder}>
                                        <Tooltip
                                            id="tooltip-top"
                                            title="Refresh"
                                            placement="bottom"
                                            classes={{tooltip: classes.tooltip}}
                                        >
                                            <Button simple color="info" justIcon>
                                                <Refresh className={classes.underChartIcons}/>
                                            </Button>
                                        </Tooltip>
                                        <Tooltip
                                            id="tooltip-top"
                                            title="Change Date"
                                            placement="bottom"
                                            classes={{tooltip: classes.tooltip}}
                                        >
                                            <Button color="transparent" simple justIcon>
                                                <Edit className={classes.underChartIcons}/>
                                            </Button>
                                        </Tooltip>
                                    </div>
                                    <h4 className={classes.cardTitle}>Appointment Graph</h4>
                                    {/*<p className={classes.cardCategory}>*/}
                                    {/*Last Campaign Performance*/}
                                    {/*</p>*/}
                                </CardBody>
                                {/*<CardFooter chart>
                                    <div className={classes.stats}>
                                        <AccessTime /> campaign sent 2 days ago
                                    </div>
                                </CardFooter>*/}
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={4}>
                            <Card chart className={classes.cardHover}>
                                <CardHeader color="danger" className={classes.cardHeaderHover}>
                                    <ChartistGraph
                                        className="ct-chart-white-colors"
                                        data={this.state.patientGraph}
                                        type="Line"
                                        options={option.options}
                                        listener={completedTasksChart.animation}
                                    />
                                </CardHeader>
                                <CardBody>
                                    <div className={classes.cardHoverUnder}>
                                        <Tooltip
                                            id="tooltip-top"
                                            title="Refresh"
                                            placement="bottom"
                                            classes={{tooltip: classes.tooltip}}
                                        >
                                            <Button simple color="info" justIcon>
                                                <Refresh className={classes.underChartIcons}/>
                                            </Button>
                                        </Tooltip>
                                        <Tooltip
                                            id="tooltip-top"
                                            title="Change Date"
                                            placement="bottom"
                                            classes={{tooltip: classes.tooltip}}
                                        >
                                            <Button color="transparent" simple justIcon>
                                                <Edit className={classes.underChartIcons}/>
                                            </Button>
                                        </Tooltip>
                                    </div>
                                    <h4 className={classes.cardTitle}>Patient Graph</h4>
                                </CardBody>
                                {/*<CardFooter chart>
                                    <div className={classes.stats}>
                                        <AccessTime /> campaign sent 2 days ago
                                    </div>
                                </CardFooter>*/}
                            </Card>
                        </GridItem>
                    </GridContainer>
                    <br/>
                </div> : <Loader/>}
            </div>
        );
    }
}

Dashboard.propTypes = {
    classes: PropTypes.object.isRequired
};


const mapStateToProps = ({global}) => ({
    reloadState: global.reloadState,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    reload
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(dashboardStyle)(Dashboard));



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx